<ng-template #collectApprovalModal let-modal>
    <div class="modal-header modal-fullscreen">
        <h4 class="modal-title" id="modal-basic-title">
            {{ 'collecting.approve-collecting' | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <p
            [innerHtml]="
                'collecting.collect-approval-modal-text'
                    | translate : { name: orderItem.orderItemName }
            "
        ></p>
        <form [formGroup]="collectionApprovalForm" class="form-horizontal">
            <div class="form-group">
                <label class="cols-sm-2 control-label" for="itemName">{{
                    'collecting.item-name' | translate
                }}</label>
                <div class="cols-sm-10">
                    <div class="input-group is-invalid">
                        <input
                            id="itemName"
                            formControlName="itemName"
                            class="form-control"
                            [readonly]="true"
                        />
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="unit-price" class="cols-sm-2 control-label">{{
                    'collecting.unit-price' | translate
                }}</label>

                <div class="cols-sm-10">
                    <div class="input-group is-invalid">
                        <input
                            type="number"
                            id="unit-price"
                            formControlName="unitPrice"
                            class="form-control"
                            placeholder="Unit Price"
                            [readonly]="
                                _collectingStatesService.hasMarkupPayment ||
                                _collectingStatesService.isMetroRetailerModel
                            "
                            required
                            autofocus
                        />
                        <div class="input-group-append">
                            <div class="input-group-text">
                                {{ 'common.currency' | translate }}
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="isSubmitted && fields.unitPrice.errors"
                        class="invalid-feedback"
                    >
                        <div *ngIf="fields.unitPrice.errors.required">
                            {{ 'collecting.unit-price' | translate }}
                            {{ 'common.is-required' | translate }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="cols-sm-2 control-label" for="quantity">{{
                    'collecting.quantity' | translate
                }}</label>

                <div class="cols-sm-10">
                    <div class="input-group is-invalid">
                        <input
                            id="orderedQuantity"
                            formControlName="orderedQuantity"
                            class="form-control"
                            placeholder="Quantity"
                            [readonly]="true"
                        />
                        <div class="input-group-append">
                            <div class="input-group-text">
                                {{ 'collecting.' + orderItem.unit | translate }}
                            </div>
                        </div>
                    </div>

                    <hr class="no-margin" />

                    <quantity
                        class="my-2"
                        id="quantity"
                        formControlName="quantity"
                        [orderItem]="orderItem"
                    ></quantity>
                    <div *ngIf="fields.quantity.errors" class="invalid-feedback">
                        <div class="error-text" *ngIf="fields.quantity.errors.required">
                            {{ 'collecting.quantity' | translate }}
                            {{ 'common.is-required' | translate }}
                        </div>
                        <div class="error-text" *ngIf="fields.quantity.errors.pattern">
                            {{ 'collecting.quantity-format-error' | translate }}
                        </div>
                    </div>

                    <div class="row">
                        <div
                            class="input-group is-invalid input-group is-invalid col-12 w-100 d-block"
                            *ngFor="
                                let orderItemDepositProduct of orderItem.orderItemDepositProductList
                            "
                        >
                            <strong
                                class="float-right"
                                *ngIf="!orderItemDepositProduct.depositUnitTypeIsOptional"
                            >
                                + {{ orderItemDepositProduct.price }}
                                {{ 'common.currency' | translate }}
                                {{ orderItemDepositProduct.unitName }}
                            </strong>
                            <ng-container
                                *ngIf="orderItemDepositProduct.depositUnitTypeIsOptional"
                            >
                                <hr />

                                <label
                                    class="control-label float-left"
                                    style="width: 40%"
                                    for="optionalDepositProductQuantity"
                                >
                                    {{ orderItemDepositProduct.depositUnitTypeName }}
                                </label>
                                <div class="input-group float-right" style="width: 60%">
                                    <input
                                        type="number"
                                        id="optionalDepositProductQuantityField"
                                        [value]="optionalDepositProductQuantity"
                                        min="0"
                                        step="1"
                                        required
                                        formControlName="optionalDepositProductQuantityField"
                                        (input)="changeDepositValue($event.target.value)"
                                        class="form-control"
                                        placeholder="Optional Deposit Product Quantity"
                                        [readonly]="false"
                                    />
                                    <div class="input-group-append">
                                        <div class="input-group-text">
                                            {{
                                                orderItemDepositProduct.depositUnitTypeName
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div
                        *ngIf="fields.optionalDepositProductQuantityField.errors"
                        class="invalid-feedback"
                    >
                        <div
                            class="error-text"
                            *ngIf="
                                fields.optionalDepositProductQuantityField.errors.required
                            "
                        >
                            {{ 'collecting.quantity' | translate }}
                            {{ 'common.is-required' | translate }}
                        </div>
                        <div
                            class="error-text"
                            *ngIf="
                                fields.optionalDepositProductQuantityField.errors.pattern
                            "
                        >
                            {{ 'collecting.quantity-format-error' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="px-3">
        <button
            [disabled]="isSubmitted"
            type="button"
            (click)="onSubmit()"
            class="btn btn-success btn-lg btn-block mt-2"
        >
            <span class="font-weight-bold text-smaller">{{
                'collecting.add-cart' | translate
            }}</span>
        </button>

        <lib-btn-close></lib-btn-close>
    </div>
</ng-template>
